export var IntelligentPhotoCaptureIQAQualityStatus;
(function (IntelligentPhotoCaptureIQAQualityStatus) {
    IntelligentPhotoCaptureIQAQualityStatus["FAIL"] = "Fail";
    IntelligentPhotoCaptureIQAQualityStatus["SUCCESS"] = "Success";
})(IntelligentPhotoCaptureIQAQualityStatus || (IntelligentPhotoCaptureIQAQualityStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureIQAQualityStatus.js.map